<template>
  <div class="priceDetails">
    <VTableRemote
      ref="tableRemoteRef"
      :iconHeader="null"
      :isSearchable="false"
      :isSelectable="false"
      :items="allCurrentBillingPricing"
      hideDefaultFooter
      :headers="tableHeaders"
      :pagination="{}"
      :isInfinitScroll="true"
    >
      <template v-slot:item="{ item, index }">
        <tr>
          <td class="text-start">
            <div :class="{manageNameColor: item.isNew, manageNameStyle: true}">
              {{ managedName === 'users' ? $t(`roles.${item.key}`) : item.key }}
            </div>
          </td>
          <td class="text-start">
            <div>
              {{ item.active }}
            </div>
          </td> <td class="text-start">
            <div>
              {{ item.inactive }}
            </div>
          </td> <td class="text-start">
            <div>
              ${{ item.price }}
            </div>
          </td> <td class="text-start">
            <div>
              ${{ item.total }}
            </div>
          </td>
        </tr>
        <!--      ligne pour le total-->
        <tr
          v-if="allCurrentBillingPricing.length - 1 === index "
          class="totalStyle"
        >
          <td
            class="text-start"
          >
            <div :class="{manageNameStyle: true}">
              {{ $t('aquassistBilling.billingRegister.labels.total') }}
            </div>
          </td>
          <td
            class="text-start d-flex"
          >
            {{ getTotalByColumn('active') }}
          </td>
          <td
            class="text-start"
          >
            {{ getTotalByColumn('inactive') }}
          </td>
          <td />
          <td
            class="text-start"
          >
            ${{ getTotalByColumn('total') }}
          </td>
        </tr>
      </template>
    </VTableRemote>
  </div>
</template>

<script>
import VTableRemote from '@/components/shared/content-views/VTableRemote.vue';
import { mapActions } from 'vuex';

export default {
    name: 'CurrentBillingPriceDetails',
    components: { VTableRemote },
    props: {
        listManage: {
            type: Array,
            default: () => {},
        },
        managedName: {
            type: String,
            default: '',
        },
        pricingPeriod: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            allCurrentBillingPricing: [],
        };
    },


    computed: {
        tableHeaders() {
            let headerManageName = this.managedName;
            if (this.managedName === 'users') {
                headerManageName = 'role';
            }
            if (this.managedName === 'features') {
                headerManageName = 'addOnFeature';
            }
            return [
                {
                    text: this.$t(`aquassistBilling.pricingManagement.labels.${headerManageName}`),
                    value: headerManageName,
                    sortable: false,
                    width: 100,
                    class: 'headManageSpacing',
                },
                {
                    text: this.$t('aquassistBilling.billingRegister.labels.active'),
                    value: 'active',
                    width: 100,
                    sortable: false,
                },
                {
                    text: this.$t('aquassistBilling.billingRegister.labels.inactive'),
                    value: 'inactive',
                    width: 100,
                    sortable: false,
                },
                {
                    text: this.$t('aquassistBilling.pricingManagement.labels.price'),
                    value: 'price',
                    width: 100,
                    sortable: false,
                },
                {
                    text: `${this.$t('aquassistBilling.billingRegister.labels.total')} ($)`,
                    value: 'total',
                    width: 100,
                    sortable: false,
                },
            ];
        },

    },

    created() {
        this.getPriceDetails();
    },

    methods: {
        ...mapActions({
            setPricingPeriodUpdatedData: 'setPricingPeriodUpdatedData',
        }),
        getTotal(active, price) {
            return active * price || 0;
        },
        getTotalByColumn(item) {
            const sums = {
                active: 'active',
                inactive: 'inactive',
                total: 'total',
            };
            const total = this.allCurrentBillingPricing.reduce((acc, element) => acc + (element[sums[item]] || 0), 0);
            return total;
        },
        getPriceDetails() {
            this.isFetching = true;
            const transformListManage = this.listManage.map(item => ({
                ...item,
                total: this.getTotal(item.active, item.price),
            }));
            this.allCurrentBillingPricing = transformListManage;
            this.isFetching = false;
        },
    },
};
</script>
<style scoped lang="scss">
@import "@/assets/styles/pricingManagement.scss";
.custom-table .v-data-table__wrapper table td:first-child:not(.v-data-table__mobile-row){
    border-left: 8px solid #b9d4f9 !important;
}
::v-deep .blocHeader{
    height: 0;
}
.pricingPeriod{
    column-gap: 1rem;
}
::v-deep .v-data-table-header{
    position: sticky;
}
::v-deep .custom-table .v-data-table__wrapper table td{
    height: 3rem;
}
::v-deep .custom-table .v-data-table__wrapper{
    height: auto !important;
    max-height: 400px;
}
::v-deep .headManageSpacing span {
    padding-left: 2rem;
}
</style>
